import { supabase } from "./supabase";

export async function requestAssetReview(accountId: string, runId: string, review?: Record<string, unknown>) {
  const { data } = await supabase.auth.getSession().catch(() => ({ data: { session: null } }));
  if (!data.session?.access_token) throw new Error("Sign in to review assets.");
  const scope = { accountId, runId };
  const correction = review?.reviewCorrectionConfirmed === true;
  const response = await fetch(review ? "/api/admin/cai-reviewed-asset" : `/api/admin/cai-reviewed-asset?${new URLSearchParams(scope)}`, {
    method: review ? correction ? "PATCH" : "POST" : "GET",
    headers: { Authorization: `Bearer ${data.session.access_token}`, "Content-Type": "application/json" },
    ...(review ? { body: JSON.stringify({ ...review, ...scope }) } : {}),
  }).catch(() => { throw new Error("Asset review is temporarily unavailable."); });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) throw new Error("Platform-operator account access is required. Preview may be read-only.");
    if (response.status === 409) throw new Error("This asset changed. Reload the review queue before approving.");
    if (response.status === 400) throw new Error("Confirm the page and complete its reviewed evidence.");
    throw new Error("Asset review is temporarily unavailable.");
  }
  return response.json().catch(() => { throw new Error("Asset review is temporarily unavailable."); });
}
